// extracted by mini-css-extract-plugin
module.exports = {"container":"description-divider_container__gqO0V","descriptionWrapper":"description-divider_descriptionWrapper__kC1wJ"};